import React, { useState, useEffect, useRef, useContext } from "react";
import "./TradingView.css";
import maingraphone from "../../../../src/Images/New_Home/images/maingraphone.png";
import imageJoin from "../../../../src/Images/New_Home/images/Join-Traders-Community.png";
import graphtwo from "../../../../src/Images/New_Home/images/graphtwo.png";
import graphfour from "../../../../src/Images/New_Home/images/graphfour.png";
import graphfive from "../../../../src/Images/New_Home/images/graphfive.png";
import graphsix from "../../../../src/Images/New_Home/images/graphsix.png";
import Group10 from "../../../../src/Images/New_Home/images/Group 10.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoginPopup from "../../CommonUI/LoginPopup/LoginPopup";
import { useSelector, useDispatch } from 'react-redux';
import { userSelector, clearState, signupUser } from '../../features/User/UserSlice';
import { faArrowRightLong, faCircleCheck, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function TradingView() {
    window.scrollTo(0, 0)
    const settings = {

        dots: false,
        infinite: true,
        speed: 1000,
        // adaptiveHeight: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        centerPadding: '40px',
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
        ]
    }
    const [show, setShow] = useState(false);
    const childRef = useRef(null);
    const dispatch = useDispatch();
    const usrname = useSelector(state => state.user.email);
    const { isFetching, isSuccess, isError, errorMessage } = useSelector(
        userSelector
    );

    useEffect(() => {
        if (isSuccess) {
            setShow(false);

        }
        if (isError) {

            // console.log(errorMessage);
            dispatch(clearState());
        }
    }, [isSuccess, isError]);
    const clickToggleLoginPopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://online.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    const clickToggleLogin = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://online.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    const clickTogglePopup = (showhide) => {
        if (isSuccess) {
            window.open(
                'https://online.moneysukh.com/',
                '_blank'
            );
        }
        else {
            childRef.current.changeTogglePopup(showhide);
        }
    }
    
  CallTrackApi("Trading View",window.location.href);
    return (
        <>
            <main class="home-new-main">

                <section class="tradeview-one">
                    <div class="container">
                        <div class="row text-center">
                            <div class="col-lg-12">

                                <h2 class="prof">Welcome,
                                    <span class="trader">Trader</span>
                                </h2>
                                <p class="sell">TradingView provides a charting platform and social network used by 50M+ traders
                                    and <br></br> investors worldwide to spot opportunities across global markets.
                                    <br></br>Moneysukh has partnered with TradingView for its charting solution. A platform which empowers traders and investors by providing live market data and analytical tools like <a href="https://www.tradingview.com/screener/" target="_blank">Screener</a>  and <a href="https://www.tradingview.com/economic-calendar/" target="_blank">Economic Calendar</a>.
                                </p>
                                <div class="monitarbox ">
                                    <img src={maingraphone} class="img-fluid" alt="image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="tradeview-two">
                    <div class="container">
                        <div class="row justify-content-center ">
                            <div class="col-lg-12">
                                <h2 class="section-heading  text-start">
                                    Join Traders Community
                                </h2>
                                
                                <img onClick={() => clickToggleLogin(true)} src={imageJoin} alt="Join Traders Community" />
                            </div>
                        </div>
                    </div>
                </section>


                <section class="tradeview-three">
                    <div class="container">
                        <h2 class="section-heading-trade center text-center">
                            Reasons to Choose <br></br>
                            <span class="trader">Tradingview</span>
                        </h2>
                        <div class="pare">
                            <div class="childboxone">
                                <img src={graphtwo} class="img-fluid desktopv" alt="image" />
                            </div>
                            <div class="childboxtwo shadow-lg ">
                                <div class="halfss">
                                </div>
                                <div class="halfs">
                                    <img src={graphtwo} class="img-fluid phonevi posleft imgonee" alt="image" />
                                    <div className="textpad">
                                        <h4>Technical analysis
                                            done right
                                        </h4>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> 100+ prebuilt most popularindicators </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> 100,000+ public indicators </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> 90+ smart drawing tools </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Volume Profile indicators </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Candlestick patterns recognition
                                        </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Multi-timeframe analysis </h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> 15+ chart types</h6>
                                        <button className="learnbtn  " onClick={() => clickTogglePopup(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pare mt-4">
                            <div class="childboxone">
                                <img src={graphfour} class="img-fluid desktopv  " alt="image" />
                            </div>
                            <div class="childboxtwo nththree shadow-lg">
                                <div class="halfss">
                                </div>
                                <div class="halfs">
                                    <img src={graphfour} class="img-fluid phonevi imgonee" alt="image" />
                                    <div className="textpad">
                                        <h4>Unmissable alerts
                                        </h4>
                                        <p class="stay">Trading alerts were never this powerful, flexible and easy to use. Cloud
                                            based, available on any device and powered by the Pine Script™ — all the bells and
                                            whistles go off — so you'll never miss a trade (unless you're taking downtime in a deep
                                            cave).</p>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Realtime alerts- technical alerts
                                            for indicators</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Range break out-breakdown
                                            monitoring</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> Alerts for indicators</h6>
                                        <h6><FontAwesomeIcon icon={faCircleCheck} /> webhook notifications</h6>

                                        <button className="learnbtn" onClick={() => clickTogglePopup(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pare mt-4">
                            <div class="childboxmidwhite midbox shadow-lg">
                                <img src={graphfive} class="img-fluid posleft desktopv nottakeimg" alt="image" />

                                <div class="halfs leftsp">
                                    <img src={graphfive} class="img-fluid posleft phonevi  imglastt" alt="image" />
                                      <div className="textpadt">
                                      <h4 class="options">Comprehensive
                                        financial analysis</h4>
                                    <p class="stay">An extensive volume of fundamental data for all major stock exchanges.
                                    </p>
                                    <h6><FontAwesomeIcon icon={faCircleCheck} /> In-depth Fundamental analysis
                                        including-ratios
                                        analysis and financial statements
                                    </h6>
                                    <h6><FontAwesomeIcon icon={faCircleCheck} /> financial valuations and use it
                                        with your
                                        existing charts
                                    </h6>
                                    <h6><FontAwesomeIcon icon={faCircleCheck} /> Cash flow analysis</h6>

                                    <button className="learnbtn btnmid" onClick={() => clickTogglePopup(true)}>Learn More <FontAwesomeIcon icon={faArrowRightLong} /></button>
                                      </div>
                                </div>
                                <div class="halfss">

                                </div>
                            </div>
                            <div class="childboxmid">
                                <img src={graphfive} class="img-fluid posleft dotimg" alt="image" />
                            </div>
                        </div>


                    </div>
                </section>


                <section class="tradeview-four">
                    <div class="container">
                        <h2 class="section-heading  center text-center str">How to Start</h2>
                        <div class="row justify-content-center">
                            <div class="col-lg-12">
                                <div class="d-flex justify-content-center ">
                                    <div class="flexone justify-content-start ">
                                        <div class="round ">1</div>
                                        <div>
                                            <p class="roundtext">Register with Moneysukh and open your account.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center ">
                                    <div class="flextwo justify-content-around">
                                        <div class="roundtwo ">2</div>
                                        <div>
                                            <p class="roundtext">Log on to mobile application or web or exe.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center ">
                                    <div class="flexone justify-content-start">
                                        <div class="roundthree ">
                                            <p>3</p>
                                        </div>
                                        <div>
                                            <p class="roundtext">select stocks from your home screen.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center ">
                                    <div class="flextwo justify-content-around">
                                        <div class="roundtwo ">4</div>
                                        <div>
                                            <p class="roundtextfour">Select the arrow button for technical.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row ">
                            <div class="col-lg-8 col-12">
                                <div class="back">
                                    <div class="textflex">
                                        <img src={graphsix} class="img-fluid textbotimg" alt="image" />
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </section>

                <section class="phoneroundview">
                    <div class="container">
                        <h2 class="section-heading center  text-center howto">How to Start</h2>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="d-flex justify-content-center">
                                    {/* <!-- <div class="mobround"><p>1</p></div> --> */}
                                    <div>
                                        <p class="roundtext">Register with Moneysukh and open your account.</p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    {/* <!-- <div><p>2</p></div> --> */}
                                    <div>
                                        <p class="roundtext">Log on to mobile application or web or exe.</p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    {/* <!-- <div><p>1</p></div> --> */}
                                    <div>
                                        <p class="roundtext">select stocks from your home screen.
                                        </p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    {/* <!-- <div><p>1</p></div> --> */}
                                    <div>
                                        <p class="roundtext">Select the arrow button for technical.
                                        </p>
                                    </div>
                                </div>
                                <img src={graphsix} class="img-fluid textbotimg mt-4" alt="image" />
                            </div>
                        </div>
                    </div>
                </section>
                <section class="open-account-scc">
                    <div class="container">
                        <div class="head">Congratulations!</div>
                        <div class="img-container">
                            <img src={Group10} class="img-fluid" alt="image" />
                        </div>
                        <div class="text-center now">
                            you have opened your <br></br>
                            trading view chart
                        </div>
                        <button class="bttn" onClick={() => clickToggleLoginPopup(true)}>
                            Get started
                        </button>
                    </div>
                </section>
                <LoginPopup show={show} ref={childRef} />
            </main>
            <script>
            </script>
        </>
    );
}

export default TradingView;